import React from 'react';
import VinicaListModalForm from './VinicaListModalForm';
import WizardDetailModalForm from '../../../../components/common/wizard_detail_popup'
import VinicaRightTabData from "./VinicaRightTabData"
import ParcelRightPanelCard from '../../../../components/modules/parcel_right_card.js';
import queryString from 'query-string'
import { Object } from 'core-js';

const IdenUserKeys = [
    "Instalação",
    "Utilizadores",
    "instalacaoDetail",
    "utilizadorDetail",
]

const tabShowKeys = [
    "Instalação",
    "Utilizadores"
]

const userKeys = [
    "idInstalacaoVinica",
    "idInstalacaoVinica_Entidade",
    "codEntidade",
    "nome",
    "idEstado",
    "entidadePrincipal",
    "dataCriado",
    "dataModificado"
]

class VínicaRightPanel extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            tab: "Utilizadores",
            popUpForm: '',
            detailPopUp: '',
            tabShowData: {
                Instalação: [],
                Utilizadores:[],
            },
            VinicaRightTabDatadiv: null,
            IdenUser:{},
            // Instalação: [],
            // Utilizadores:[],
            displayDataArray: {
                Instalação: this.props.Parcel["Instalação"],
                Utilizadores:[],
            },
            idInstalacaoVinica:null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        console.log('mount of the panel worked by superman and his powers', this.props)
        //this.setInitialValues()

        let IdenUser = {}
        let tabShowData = {}
        if(this.props.Parcel) {
            IdenUserKeys.map(key => {
                IdenUser[key] = this.props.IdenUser[key] || ""
            })
            tabShowKeys.map(key => {
                tabShowData[key] = [...this.props.Parcel[key]]
            })
            console.log("this is the tab show data that i wanted", tabShowData, this.props.Parcel)
    
            this.setState({
                IdenUser,
                tabShowData,
                //displayDataArray: {...this.props.Parcel}
            }, () => this.setTabDetail(this.state.tab))
        }
        
    }

    setInitialValues = () => {
        let IdenUser = {}
        let tabShowData = {}
        if(this.props.Parcel) {
            IdenUserKeys.map(key => {
                IdenUser[key] = this.props.IdenUser[key] || ""
            })
            tabShowKeys.map(key => {
                tabShowData[key] = [...this.props.Parcel[key]]
            })
            console.log("this is the tab show data that i wanted", tabShowData, this.props.Parcel)
    
            this.setState({
                IdenUser,
                tabShowData,
                //displayDataArray: {...this.props.Parcel}
            }, () => this.setTabDetail(this.state.tab))
        }
        
    }

    componentDidUpdate(prevProp) {
        if (prevProp.date !== this.props.date) {
            console.log('update of the panel worked by superman and his powers', this.props)
            this.VinicaRightTabData();
            // this.defaultLoader()
        }
        if(JSON.stringify(this.props.Parcel) !== JSON.stringify(prevProp.Parcel)) {
            this.setState({
                IdenUser: this.props.IdenUser,
                tabShowData: {...this.props.Parcel},
                displayDataArray: {...this.props.Parcel}
            },() => {
                this.VinicaRightTabData()
            })
            //this.setInitialValues()
            console.log("the condition of the update issssssss", JSON.stringify(this.props.Parcel) !== JSON.stringify(prevProp.Parcel))
        }
        if(prevProp.idInstalacaoVinica != this.props.idInstalacaoVinica) {
            this.setState({
                idInstalacaoVinica: this.props.idInstalacaoVinica
            },() => {
                console.log("spidereman id instalacao ", this.state.idInstalacaoVinica)
            })
        }
    }

    updateTabOnly = (tab) => {
        this.setState({
            tab
        }, () => this.setTabDetail(tab))
    }

    setTabDetail = (tab) => {
        this.VinicaRightTabData();
    }

    insertClickPopUp = () => {
        this.setState({
            popUpForm: ""
        })

        let popUpForm = (
            <VinicaListModalForm
                date={new Date()}
                IdenUser={this.state.IdenUser}
                tab={this.state.tab}
                closePopup={() => this.props.closePopup()}
                tabShowData={this.state.tabShowData[this.state.tab]}
                //IdenUser={this.state.IdenUser} // Marco
                displayDataArray={this.state.displayDataArray[this.state.tab]}
                getDataToPanel={(data, displayData, IdenUserData, tab) => this.getDataToPanel(data, displayData, IdenUserData, tab)}
                idInstalacaoVinica={this.state.idInstalacaoVinica}
                vasilhaUserArray={this.props.vasilhaUserArray}
            />
        )
        this.setState({
            popUpForm
        })
    }

    

    detailClick = (row) => {
        let detailPopUp = (
            <WizardDetailModalForm closePopup={() => this.props.closePopup()} listData={row} tab={'detail'} />
        )
        this.setState({
            detailPopUp
        })
    }

    VinicaRightTabData = () => {
        console.log('the tab data worked')
        console.log(this.state.tab)
        let VinicaRightTabDatadiv = (
            <VinicaRightTabData
                isInEdit={this.props.isInEdit}
                date={new Date()}
                tab={this.state.tab}
                tabShowData={this.state.tabShowData[this.state.tab]}
                detailClick={(id) => this.detailClick(id)}
                insertClickPopUp={() => this.insertClickPopUp()}
                IdenUser={this.state.IdenUser}
                getDisplayData={(row, tab) => this.getDisplayData(row, tab)}
                displayData={this.state.displayDataArray[this.state.tab]}
            />
        )
        this.setState({
            VinicaRightTabDatadiv
        })
    }

    getRightPanelData=(displayDataArray,IdenUser)=>{
        
    }

    getDisplayData = (row, tab) => {
        let displayDataArray = {...this.state.displayDataArray}
        let alreadyExists = false
        Object.keys(displayDataArray).map(key => {
            if(key === tab) {
                displayDataArray[tab].map(obj => {
                    if(obj.nif === row.nif) alreadyExists = true
                })
                if(!alreadyExists)
                    displayDataArray[tab] = [...this.state.displayDataArray[tab], row]
                else
                    displayDataArray[tab] = [...this.state.displayDataArray[tab]]
            }
            else {
                displayDataArray[tab] = [...this.state.displayDataArray[tab]]
            }
        })
        //this.props.getVasilahData(displayDataArray)
        this.setState({
            displayDataArray
        },()=>{

            this.props.getdisplayDataArray(this.state.displayDataArray, this.state.IdenUser);
        })
    }

    getDataToPanel = (data, displayData, IdenUserData, tab) => {
        console.log("the tab is ", tab)
        
        let tabShowData = {...this.state.tabShowData}
        tabShowData[tab] = data

        let displayDataArray = {...this.state.displayDataArray}
        displayDataArray[tab] = displayData

        let IdenUser = {...this.state.IdenUser, ...IdenUserData}
        this.setState({
            tabShowData,
            IdenUser,
            displayDataArray
        },() => {
            
            this.VinicaRightTabData();
            this.props.getdisplayDataArray(this.state.displayDataArray, this.state.IdenUser);
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        let params = queryString.parse(window.location.search)
        let id = params.id ? params.id : ''
        return (
            <div className="last-box">
                <ParcelRightPanelCard 
                    cardData={this.props.Parcel} 
                    id={id} 
                    cardFor="vinica" 
                    leakage={this.props.leakage}
                />
                {
                    this.props.checkMandatoryFields && this.state.displayDataArray["Instalação"].length === 0 &&
                    <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                }
                <div className="bg-white">
                    <div className="right-tab">
                        <ul className="nav nav-tabs d-flex text-center">
                            {/* <li className="nav-item-vincia flex-grow-1">
                                <a onClick={() => this.updateTabOnly('Instalação')} className="nav-link active" data-toggle="tab" href="#Instalação">PROPRIETÁRIO INSTALAÇÃO</a>
                            </li> */}
                            <li className="nav-item flex-grow-1">
                                <a className="nav-link" onClick={() => this.updateTabOnly('Utilizadores')} data-toggle="tab" href="#Utilizadores">UTILIZADORES</a>
                            </li>
                        </ul>
                        {
                            this.state.VinicaRightTabDatadiv
                        }
                    </div>
                    {  (this.state.tab==="Instalação" || (this.state.tab==="Utilizadores" && this.props.isInEdit))  &&
                    <div className="modal left-popup" id="vinica-left-popup">
                        <div className="modal-dialog modal-sm">
                            {
                              this.state.popUpForm
                            }
                        </div>
                    </div>
                    }
                    <div className="modal left-popup" id="vinica-left-detail-popup">
                        <div className="modal-dialog modal-sm">
                            {
                                this.state.detailPopUp
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default VínicaRightPanel;